export const RATING_REASONS = [
  {
    id: 1,
    label: 'Included inaccurate info',
    sortOrder: 1,
  },
  {
    id: 2,
    label: 'Missing important details',
    sortOrder: 2,
  },
  {
    id: 3,
    label: 'Other',
    sortOrder: 3,
  },
];
